import { UtensilsCrossed, ShoppingBag, CalendarCheck, Globe, Store, Repeat } from 'lucide-react'

// What a store can offer; its plan decides how many at once.
// includes: what the service brings to the store (shown at sign-up).
// add: the button that adds it to a store already running another service.
export const SERVICES = [
  {
    id: 'menu', icon: UtensilsCrossed, title: 'Menu & pre-orders', desc: 'A QR menu for restaurants and cafés: dine-in, pickup and delivery orders, kitchen screen and tables.',
    add: 'Add a restaurant / café menu',
    includes: ['QR menu for every table', 'Dine-in, pickup and delivery orders', 'POS for walk-in orders', 'Kitchen screen with order sound', 'Tables and QR codes', 'Table reservations', 'Recipes and ingredient stock', 'Printed bills and kitchen tickets'],
  },
  {
    id: 'store', icon: ShoppingBag, title: 'Online store', desc: 'Sell products with photos, options, stock and delivery prices per city.',
    add: 'Add an online store',
    includes: ['Product galleries and variants', 'Categories and featured products', 'Stock that updates itself', 'Low-stock email alerts', 'Delivery prices for every city in the Gulf', 'Card, bank transfer or cash on delivery', 'Customer accounts with order history', 'Printed bills'],
  },
  {
    id: 'bookings', icon: CalendarCheck, title: 'Bookings & appointments', desc: 'Salons, clinics, offices and rooms: customers book a time online.',
    add: 'Add bookings & reservations',
    includes: ['Services with price and duration', 'Live availability calendar', 'Opening hours and days off', 'Booking confirmations by email', 'Appointments, hotel rooms or offices', 'All bookings in one list'],
  },
]

const BOOKING_TYPES = ['appointments', 'hotel', 'office']

// A store's services; older stores run the one matching their business type.
export function servicesOf(services, businessType) {
  const list = Array.isArray(services) ? SERVICES.map(s => s.id).filter(id => services.includes(id)) : []
  if (list.length) return list
  if (businessType === 'ecommerce') return ['store']
  if (BOOKING_TYPES.includes(businessType)) return ['bookings']
  return ['menu']
}

// How the online store sells (saved as the store mode).
export const STORE_MODES = [
  { value: 'both', icon: Repeat, label: 'Online + in my shop', desc: 'A website with delivery and pickup, plus the POS for counter sales.' },
  { value: 'online', icon: Globe, label: 'Online store only', desc: 'Sell on your website with delivery and pickup.' },
  { value: 'shop', icon: Store, label: 'Shop with POS', desc: 'Sell at the counter with the POS. Your website shows your products and customers order to collect.' },
]

// Countries at sign-up: they set the store's currency and time zone.
export const COUNTRIES = [
  { code: 'OM', name: 'Oman', currency: 'OMR' },
  { code: 'SA', name: 'Saudi Arabia', currency: 'SAR' },
  { code: 'AE', name: 'United Arab Emirates', currency: 'AED' },
  { code: 'QA', name: 'Qatar', currency: 'QAR' },
  { code: 'KW', name: 'Kuwait', currency: 'KWD' },
  { code: 'BH', name: 'Bahrain', currency: 'BHD' },
  { code: 'JO', name: 'Jordan', currency: 'JOD' },
  { code: 'IQ', name: 'Iraq', currency: 'IQD' },
  { code: 'EG', name: 'Egypt', currency: 'EGP' },
  { code: 'MA', name: 'Morocco', currency: 'MAD' },
]

// What every plan includes, shown at sign-up.
export const INCLUDED = ['POS & cashier', 'Loyalty points', 'QR codes & tables', 'Online payments', 'Printed bills', 'New order alerts', 'Arabic & English', 'Customer accounts']
